import { useState } from 'react'
import { useParams } from 'react-router-dom'

import FormDesignEditor from '@/components/container/modules/ugc/FormDesignEditor'
import IncentivePanel from '@/components/container/modules/ugc/IncentivePanel'
import MailQueuePanel from '@/components/container/modules/ugc/MailQueuePanel'
import MailScheduleEditor from '@/components/container/modules/ugc/MailScheduleEditor'
import MailSenderEditor from '@/components/container/modules/ugc/MailSenderEditor'
import MailTemplateEditor from '@/components/container/modules/ugc/MailTemplateEditor'
import ManualRequestPanel from '@/components/container/modules/ugc/ManualRequestPanel'
import ReviewFieldEditor from '@/components/container/modules/ugc/ReviewFieldEditor'

import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageTitle from '@/components/view/molecules/title/PageTitle'

/**
 * レビュー依頼メール。
 *
 * セクションが増えて1ページでは長すぎるため、仕事の種類で4タブに分ける。
 *
 *   メール送信設定 … 送信モード・差出人・送信対象／文面／送信タイミングと文面の設定
 *   投稿フォーム設定 … デザイン／項目（プレビュー付き）
 *   送信管理 … 送信の状況／個別に依頼する
 *   投稿特典管理 … 特典対象者の一覧・CSV・処理済み管理
 *
 * 分け方は「設定する（たまに触る）」と「運用する（日々見る）」の区別。
 */

const TABS = [
  { key: 'mail', label: 'メール送信設定' },
  { key: 'form', label: '投稿フォーム設定' },
  { key: 'queue', label: '送信管理' },
  { key: 'incentive', label: '投稿特典管理' }
] as const

type TabKey = (typeof TABS)[number]['key']

const UGCMailPage = () => {
  const { siteId: siteIdParam } = useParams()
  const siteId = Number(siteIdParam)
  const [tab, setTab] = useState<TabKey>('mail')

  return (
    <Main type={MainLayoutType.FULL}>
      <PageTitle
        title='レビュー依頼管理'
        description='購入者へのレビュー依頼メールと投稿フォームを設定し、送信状況・投稿特典を管理します。送信は既定で止まっています。'
      />

      <div className='mb-4 flex flex-wrap gap-1 border-b border-border-primary'>
        {TABS.map((t) => (
          <button
            key={t.key}
            type='button'
            onClick={() => setTab(t.key)}
            className={
              tab === t.key
                ? 'text-size-13 -mb-px border-b-2 border-border-brand px-4 py-2 font-bold'
                : 'text-size-13 text-secondary -mb-px border-b-2 border-transparent px-4 py-2'
            }
          >
            {t.label}
          </button>
        ))}
      </div>

      <Content>
        {tab === 'mail' && (
          <>
            <MailSenderEditor siteId={siteId} />
            <MailTemplateEditor siteId={siteId} />
            <MailScheduleEditor siteId={siteId} />
          </>
        )}
        {tab === 'form' && (
          <>
            <FormDesignEditor siteId={siteId} />
            <ReviewFieldEditor siteId={siteId} />
          </>
        )}
        {tab === 'queue' && (
          <>
            <MailQueuePanel siteId={siteId} />
            <ManualRequestPanel siteId={siteId} />
          </>
        )}
        {tab === 'incentive' && <IncentivePanel siteId={siteId} />}
      </Content>
    </Main>
  )
}

export default UGCMailPage
